import classNames from "classnames";
import React, { ReactNode } from "react";
import BsDropdown from "reactstrap/lib/Dropdown";
import DropdownMenu from "reactstrap/lib/DropdownMenu";
import DropdownToggle from "reactstrap/lib/DropdownToggle";

import Styles from "./Dropdown.module.scss";

export interface DropdownProps {
    DropdownToggleBtn: ReactNode;
    children: ReactNode;
    isOpen: boolean;
    handleToggle: () => void;
    id?: string;
    containerClassName?: string;
    dropdownClassName?: string;
    dropdownToggleClassName?: string;
    disabled?: boolean;
    direction?: "up" | "right" | "down" | "left";
    onBlur?: () => void;
}

const Dropdown = ({
    id,
    children,
    DropdownToggleBtn,
    isOpen = false,
    handleToggle,
    containerClassName,
    dropdownClassName,
    dropdownToggleClassName,
    disabled,
    direction,
    onBlur
}: DropdownProps) => {
    return (
        <div className={containerClassName}>
            <BsDropdown isOpen={isOpen} toggle={handleToggle} direction={direction} onBlur={onBlur} id={id}>
                <DropdownToggle
                    className={classNames(`${isOpen ? "active" : ""}`, dropdownToggleClassName)}
                    disabled={disabled}
                    tag="span"
                >
                    {DropdownToggleBtn}
                </DropdownToggle>
                <DropdownMenu
                    className={classNames(Styles.dropdownMenu, dropdownClassName)}
                    style={{ zIndex: 9999 }}
                    translate="no"
                >
                    {children}
                </DropdownMenu>
            </BsDropdown>
        </div>
    );
};

export default Dropdown;
